const LOGO_CONTAINER = 'logo-img-container';
const DEFAULT_LOGO = 'default-logo-image';

class AppService {
	constructor() {
		this.currentApp = null;
		this.currentGrant = null;
		this.subscribers = [];
	}

	/**
	 * subscribe가 동작하면 menuController에서 아이콘을 변경하고 state를 바꾸기 위해서 추가
	 */
	subscribe(callback) {
		this.subscribers.push(callback);
	}

	next(app, grant) {
		this.subscribers.forEach(function(callback) {
			callback(app, grant);
		});
	}

	startApp(app, grant) {
		if (!app) return;
		this.currentApp = app;
		this.currentGrant = grant;
		this.next(app, grant);
	}

	stopApp() {
		this.currentApp = null;
		this.currentGrant = null;
		this.next(null);
	}
}

export default AppService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/AppService.js